module.exports = "/_next/static/images/background-fd3412c0569c27c19aa71545e5f54b08.png";